import React from 'react';
import { User } from '@/utils/helpers';

interface IntroSectionProps {
  description: string;
  user: Partial<User> | null;
}

export const IntroSection: React.FC<IntroSectionProps> = ({ description, user }) => {
  return (
    <section id="intro" className="flex flex-col gap-6 scroll-mt-8">
      <h1 className="text-3xl font-bold border-b border-zinc-700 pb-4">Introduction</h1>
      <p className="text-zinc-400">{description}</p>
      <p className="text-zinc-400">
        <strong>Note:</strong> This changelog tracks all significant updates to TONE3000. We release
        updates regularly to improve performance, add new features, and fix bugs.
      </p>
      <div className="flex flex-col gap-2">
        <h3 className="text-lg font-semibold">How to Stay Updated</h3>
        <ul className="list-disc list-inside text-zinc-400 space-y-1">
          <li>Check this page regularly for the latest updates</li>
          <li>
            Join our{' '}
            <a
              href="https://discord.gg/wEV8uEWDnb"
              className="text-white hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Discord community
            </a>{' '}
            for discussions
          </li>
        </ul>
      </div>
      <div className="flex flex-col gap-2">
        <h3 className="text-lg font-semibold">Versioning</h3>
        <p className="text-zinc-400">
          We follow semantic versioning (MAJOR.MINOR.PATCH). Major releases include breaking
          changes, minor releases add new features, and patch releases include bug fixes and
          improvements.
        </p>
      </div>
      <div className="flex flex-col gap-2">
        <h3 className="text-lg font-semibold">Feedback & Suggestions</h3>
        <p className="text-zinc-400">
          Have ideas for new features or improvements? We'd love to hear from you! Contact{' '}
          <a href="mailto:support@tone3000.com" className="text-white hover:underline">
            support@tone3000.com
          </a>{' '}
          or join our{' '}
          <a
            href="https://discord.gg/wEV8uEWDnb"
            className="text-white hover:underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Discord community
          </a>{' '}
          for discussions. You can also report issues for open source projects on our{' '}
          <a
            href="https://github.com/tone-3000"
            className="text-white hover:underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            GitHub
          </a>
          .
        </p>
      </div>
    </section>
  );
};
